<script lang="ts" setup>
import { computed } from "vue";
import { useI18n } from "vue-i18n";

import OmniTooltip from "@/components/omni/OmniTooltip.vue";
import { useChangeOrderStatus } from "@/composables";
import { resolveDisableRules } from "@/utils/disableRules";

import type { OrderStatus } from "@/constants/order";
import type { DisableRule } from "@/types/validation";

const { t } = useI18n();
const { createDisableChangeOrderStatusRules } = useChangeOrderStatus();

const props = defineProps<{
  orderStatus?: OrderStatus;
}>();

const emit = defineEmits<{
  click: [];
}>();

const disableState = computed<DisableRule>(() => {
  return resolveDisableRules(createDisableChangeOrderStatusRules(() => props.orderStatus));
});
</script>

<template>
  <omni-tooltip :disabled="!disableState.disabled" full-width>
    <template #activator>
      <v-btn
        :disabled="disableState.disabled"
        class="mt-3 text-uppercase font-weight-600 width-100"
        color="primary"
        data-qa="change-order-status"
        variant="outlined"
        @click="emit('click')"
      >
        {{ t("orders.change-status") }}
      </v-btn>
    </template>

    <div v-for="reason in disableState.reasons" :key="reason">{{ reason }}</div>
  </omni-tooltip>
</template>
